export default "__VITE_ASSET__CjAeKqPU__"